import { Injectable } from '@angular/core';

import { InformationsFormFactory } from './informations-form.factory';
import { Informations, InformationsFormGroup } from './informations-form.types';
import { PersistenceResource } from '@infra/persistence';
import { BaseForm } from '@app/shared/interfaces/form';

@Injectable({
  providedIn: 'root',
})
export class InformationsForm extends BaseForm<Informations, InformationsFormGroup> {
  constructor(persistenceResource: PersistenceResource) {
    super();

    this.formGroup = new InformationsFormFactory().create();
    const state = persistenceResource.getInformations();

    if (state) {
      this.formGroup.patchValue(state);
    }
  }
}
